import QrScanStyles from 'shared/style/qrScanStyles'

const QrScannerError = ({error}) => {
	if (!error) return null

	return (
		<QrScanStyles.ErrorContainer>
			<QrScanStyles.ErrorText>{error}</QrScanStyles.ErrorText>
		</QrScanStyles.ErrorContainer>
	)
}

export default QrScannerError
